import { Column } from 'react-table';

export const rulePerformanceRejectColumns: Column<RulePerformanceTableItem>[] = [
    {
        accessor: 'rule',
        Header: 'Rule ID'
    },
    {
        accessor: 'matches',
        id: 'reject',
        Header: 'Matches'
    }
];

export const rulePerformanceAllColumns: Column<RulePerformanceTableItem>[] = [
    {
        accessor: 'rule',
        Header: 'Rule ID'
    },
    {
        accessor: 'matches',
        id: 'all',
        Header: 'Matches'
    }
];
